<template>
  <el-card class="faq-panel">
    <el-collapse v-model="activeTab" accordion>
      <el-collapse-item v-for="item in items" :key="item.id" :name="item.id">
        <template #title>
          <span @click="event(item.id)">{{ item.attributes.title }}</span>
        </template>
        <div>
          <div class="faq-content" v-html="item.attributes.content" />
        </div>
      </el-collapse-item>
    </el-collapse>
  </el-card>
</template>
<script lang="ts">
import { computed, ref, defineComponent, watch } from 'vue'
import { useFaqsStore } from '@/store/modules/faqs'

export default defineComponent({
  name: 'Faqs',
  components: {},
  props: {},
  setup() {
    const faqsStore = useFaqsStore()
    const loading = computed(() => faqsStore.listLoading)
    const items = computed(() => faqsStore.currentItems)

    const activeTab = ref(0)

    watch(items, (value, oldValue) => {
      if (value) {
        activeTab.value = value[0].id
      }
    })

    const event = (id: any) => {
      faqsStore.SendStat({ id: id, event: true })
    }
    return { activeTab, items, loading, event }
  }
})
</script>
<style lang="scss" scoped>
:deep(iframe) {
  border: 0;
  outline: none;
}
</style>
